import ActionTypes           from '../../ActionTypes';
import { fetchTranslations}  from '../../services/TranslationsService';
import { getSession }        from '../../services/SessionService';
import { TranslationsError } from '../../reduxTypes';
import { Action }            from 'redux';

export interface TranslationsErrorAction extends Action {
    error: TranslationsError;
}

function loadingTranslations() {
    return {
        type: ActionTypes.TRANSLATIONS_LOADING
    };
}

function loadTranlationsSuccess() {
    return {
        type: ActionTypes.TRANSLATIONS_LOADED,
    };
}

function loadTranlationsError(error: TranslationsError): TranslationsErrorAction {
    return {
        type: ActionTypes.TRANSLATIONS_ERROR,
        error
    };
}

export function loadTranslations() {
    return async function loadTranslationsAction(dispatch) {
        dispatch(loadingTranslations());
        try {
            const session = await getSession();
            await fetchTranslations(session);

            dispatch(loadTranlationsSuccess());
        } catch (error) {
            dispatch(loadTranlationsError(error));
        }
    };
}



// WEBPACK FOOTER //
// ./src/sections/Translations/TranslationsActions.ts